package team.platforma.aicombo.activity.chat.component

import aicombo.composeapp.generated.resources.Res
import aicombo.composeapp.generated.resources.navigation_chat_gpt_title
import team.platforma.aicombo.activity.chat.component.fragment.ChatFragment
import team.platforma.aicombo.activity.chat.component.fragment.ChatFragment2
import team.platforma.extra_nav.component.component_of_activity.Component

object ChatComponent : Component(
    route = "chat_component",
    fragments = listOf(ChatFragment),
    label = Res.string.navigation_chat_gpt_title,
)